import { render, staticRenderFns } from "./MobilePreview.vue?vue&type=template&id=387921ac&scoped=true"
import script from "./MobilePreview.vue?vue&type=script&lang=js"
export * from "./MobilePreview.vue?vue&type=script&lang=js"
import style0 from "./MobilePreview.vue?vue&type=style&index=0&id=387921ac&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387921ac",
  null
  
)

export default component.exports